// Estados
const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

// Indicador de Facturación
const NO_FACTURABLE = 0;
const ITBIS_18 = 1;
const ITBIS_16 = 2;
const ITBIS_0 = 3;
const EXENTO = 4;
const ITBIS_18_DEL_10 = 5;
const NO_FACTURABLE_LABEL = 'No Facturable';
const ITBIS_18_LABEL = 'ITBIS 18%';
const ITBIS_16_LABEL = 'ITBIS 16%';
const ITBIS_0_LABEL = 'ITBIS 0%';
const EXENTO_LABEL = 'Exento';
const ITBIS_18_DEL_10_LABEL = 'ITBIS 18% del 10%';

// Indicador de Bien o Servicio
const BIEN = 0;
const SERVICIO = 1;
const BIEN_LABEL = 'Bien';
const SERVICIO_LABEL = 'Servicio';

export class Item {
    static get ESTATUS_LIST() {
        return [
            { value: "", label: "Todos" },
            { value: "A", label: "Activo" },
            { value: "I", label: "Inactivo" },
        ];
    }

    static get INDICADOR_BIEN_O_SERVICIO_LIST() {
        return [
            { value: null, label: "Todos" },
            { value: BIEN, label: BIEN_LABEL },
            { value: SERVICIO, label: SERVICIO_LABEL },
        ];
    }

    static get INDICADOR_FACTURACION_LIST() {
        return [
            { value: null, label: "Todos" },
            { value: NO_FACTURABLE, label: NO_FACTURABLE_LABEL },
            { value: ITBIS_18, label: ITBIS_18_LABEL },
            { value: ITBIS_16, label: ITBIS_16_LABEL },
            { value: ITBIS_0, label: ITBIS_0_LABEL },
            { value: EXENTO, label: EXENTO_LABEL },
            { value: ITBIS_18_DEL_10, label: ITBIS_18_DEL_10_LABEL },
        ];
    }

    static getFacturacionTexto(indicador) {
        switch (indicador) {
            case NO_FACTURABLE:
                return NO_FACTURABLE_LABEL;
            case ITBIS_18:
                return ITBIS_18_LABEL;
            case ITBIS_16:
                return ITBIS_16_LABEL;
            case ITBIS_0:
                return ITBIS_0_LABEL;
            case EXENTO:
                return EXENTO_LABEL;
            case ITBIS_18_DEL_10:
                return ITBIS_18_DEL_10_LABEL;
        }
    }

    static getEstatusTexto(estatus) {
        switch (estatus) {
            case ESTATUS_ACTIVO:
                return ESTATUS_ACTIVO_LABEL;
            case ESTATUS_INACTIVO:
                return ESTATUS_INACTIVO_LABEL;
        }
    }

    static getIndicadorBienServicioTexto(indicador) {
        switch (indicador) {
            case BIEN:
                return BIEN_LABEL;
            case SERVICIO:
                return SERVICIO_LABEL;
        }
    }

    static get DEFAULT_ESTATUS_VALUE() {
        return ESTATUS_ACTIVO;
    }

    static get PROPIEDADES_EXPORTAR() {
        const propiedades = [
            { value: "IdSec", label: "Id" },
            { value: "Nombre", label: "Nombre" },
            { value: "Descripcion", label: "Descripcion" },
            { value: "EstatusDesc", label: "Estatus" },
            { value: "CrearUsuario", label: "Crear Usuario" },
            { value: "FechaCreacion", label: "Fecha Creación" },
            { value: "ActualizarUsuario", label: "Actualizar Usuario" },
            { value: "FechaActualizacion", label: "Fecha Actualización" },
            { value: "IndicadorBienOServicioDesc", label: "Tipo" },
            { value: "CodigoBarra", label: "Código de Barra" },
            { value: "IndicadorFacturacionDesc", label: "Tipo ITBIS" },
            { value: "PrecioUnitario", label: "Precio" },
            { value: "CategoriaDesc", label: "Categoria" },
        ];
        return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
    }
}
